import BoltBanner from "../boltClone/BoltBanner";
import BoltOwnCode from "../boltClone/BoltOwnCode";
import { lazy, Suspense } from "react";

const LyftTeamlogo = lazy(() => import("../LyftClone/LyftTeamlogo"));
const BoltSuperlative = lazy(() => import("../boltClone/BoltSuperlative"));
const BoltNeed = lazy(() => import("../boltClone/BoltNeed"));
const BoltDrive = lazy(() => import("../boltClone/BoltDrive"));
const BoltJourney = lazy(() => import("../boltClone/BoltJourney"));
const BoltBuild = lazy(() => import("../boltClone/BoltBuild"));
const BoltForYou = lazy(() => import("../boltClone/BoltForYou"));
const BoltDevelopement = lazy(() => import("../boltClone/BoltDevelopement"));
const BoltCustom = lazy(() => import("../boltClone/BoltCustom"));
const BoltSmart = lazy(() => import("../boltClone/BoltSmart"));
const BoltWhiteLabel = lazy(() => import("../boltClone/BoltWhiteLabel"));
const BoltGen = lazy(() => import("../boltClone/BoltGen"));
const BoltGlobal = lazy(() => import("../boltClone/BoltGlobal"));
const ShuttleAppreciation = lazy(() => import("../../shuttle_software/ShuttleAppreciation"));
const TaxiFaq = lazy(() => import("../../taxiDispatchSoftware/TaxiFaq"));

const bannerData = {
  class: "bolt-banner",
  titlePart1: "Vá de Táxi Clone App",
  titlePart2: "Development Company",
  description: "Leading experts in creating scalable, secure, and fully customizable taxi booking apps tailored for seamless user experiences.",
  image: "/assets/home/bolt-banner.webp",
  btn1: "contact us",
  btn2: "watch demo",
  counter1: {
    number: "2000+",
    text: "Apps Launched"
  },
  counter2: {
    number: "100+",
    text: "Expert Developers"
  },
  counter3: {
    number: "250+",
    text: "Happy Clients"
  },
  breadcrumbData: {
    newClass: "white-breadcrumb",
    list: [
      {
        page: "Home",
        slug: "/"
      },
      {
        page: "vade taxi Clone App",
        slug: ""
      },
    ]
  }
};

const OwnCodeData = {
  box1: {
    image: "/assets/home/bolt-own-code-1.webp",
    title: "Own the Entire Source Code",
  },
  box2: {
    image: "/assets/home/bolt-own-code-2.webp",
    title: "Outstanding UI & Superior UX",
  },
  box3: {
    image: "/assets/home/bolt-own-code-3.webp",
    title: "Fully Customized Solution",
  },
  box4: {
    image: "/assets/home/bolt-own-code-4.webp",
    title: "Next-Level Features",
  },
}

const superlativeData = {
  titlePart1: "Why",
  titlePart2: "Vá de Táxi Clone App",
  titlePart3: "Superlative For Taxi Booking Businesses?",
  description1: "In today’s fast-moving urban environments, passengers expect convenience and reliability at every step. That’s where the Vá de Táxi Clone app by Mobility Infotech takes the spotlight. Crafted specifically for Brazil’s dynamic ride-hailing industry, our all-in-one solution brings together everything needed to run a successful taxi business. Whether you're a budding entrepreneur launching a taxi startup or an established operator looking to digitize your fleet, our Vá de Táxi Clone app seamlessly fuses powerful tech with effortless usability. From quick ride-matching and live tracking to automated billing and secure payment options, the app is designed to create an intuitive and rewarding experience for both passengers and drivers.",
  description2: "What truly sets our solution apart isn’t just the tech—it’s the competitive edge it gives you. With support for white-label branding, geo-fencing, surge pricing, regional promotions, and multilingual capabilities, the Vá de Táxi Clone adapts to local demands across Brazil. Its core scalability ensures your platform evolves as your business grows. In a competitive marketplace, having the right tech isn’t just an option—it’s a necessity. Choose Mobility Infotech’s Vá de Táxi Clone app—the smarter, quicker, and scalable way to accelerate your ride-hailing business.",
}

const needData = {
  titlePart1: "Taxi",
  titlePart2: "App Development Solutions",
  titlePart3: "for Every Business Need",
  description: "Powering Canada’s transportation evolution—one ride at a time.",
  boxes: [
    {
      image: "/assets/home/bolt-need-1.webp",
      title: "On-Demand Taxi Booking Apps",
      para: "Launch real-time ride-booking services with instant driver assignment, live tracking, and secure payments. Perfect for startups or operators wanting to offer Vá de Táxi-style reliability across Brazilian cities.",
      btn: "Request a free demo",
    },
    {
      image: "/assets/home/bolt-need-2.webp",
      title: "Ride-sharing or Carpooling Apps",
      para: "Promote budget-friendly and eco-conscious commuting with carpooling features. Smart passenger-driver matching, fare splitting, and optimized routes serve the needs of busy urban travellers.",
      btn: "Request a free demo",
    },
    {
      image: "/assets/home/bolt-need-3.webp",
      title: "Corporate Taxi Booking Apps",
      para: "Offer businesses centralized ride management. Our corporate solution allows employee scheduling, usage monitoring, and consolidated invoicing—perfect for HR teams and corporate mobility.",
      btn: "Request a free demo",
    },
    {
      image: "/assets/home/bolt-need-4.webp",
      title: "Rental or Hourly Taxi Booking Apps",
      para: "Enable passengers to book taxis by the hour or for long-distance travel. Great for tourists, professionals, and anyone needing flexible ride options.",
      btn: "Request a free demo",
    },
    {
      image: "/assets/home/bolt-need-5.webp",
      title: "Luxury & Limousine Booking Apps",
      para: "Serve premium customers with VIP features such as luxury car selection, real-time chauffeur tracking, and customized service. Ideal for events, hotels, and executive needs.",
      btn: "Request a free demo",
    },
    {
      image: "/assets/home/bolt-need-6.webp",
      title: "Bike Taxi Booking Apps",
      para: "Target solo travellers and budget users with fast and affordable two-wheeler transport options. Ideal for traffic-heavy city centres and last-mile deliveries.",
      btn: "Request a free demo",
    },
    {
      image: "/assets/home/bolt-need-7.webp",
      title: "White-Label Taxi Booking Apps",
      para: "Quickly launch your own branded taxi platform using our white-label solutions. Customize design, logo, and functionality to suit your unique identity.",
      btn: "Request a free demo",
    },
    {
      image: "/assets/home/bolt-need-8.webp",
      title: "Airport Transfer Taxi Apps",
      para: "Simplify airport commutes with integrated scheduling, flight tracking, and live driver notifications. Perfect for travel agencies and operators near Brazil's major airports.",
      btn: "Request a free demo",
    },
    {
      image: "/assets/home/bolt-need-9.webp",
      title: "Electric Vehicle (EV) Taxi Apps",
      para: "Promote sustainability with EV-specific apps. Includes charging station integration, eco-routing, and green fleet management for Brazil’s growing clean transport sector.",
      btn: "Request a free demo",
    },
    {
      image: "/assets/home/bolt-need-10.webp",
      title: "Paratransit or Accessible Taxi Apps",
      para: "Meet accessibility needs with vehicle and app features for passengers with mobility challenges. Fully compliant with Brazil’s accessibility guidelines.",
      btn: "Request a free demo",
    },
  ],
}

const driveData = {
  titlePart1: "Drive Your Success with Brazil’s ",
  titlePart2: "Leading Taxi App Development Experts",
  description: "Embrace innovation with our advanced ride-hailing app development and see the results:",
  image: "/assets/home/bolt-drive.webp",
  vector: "/assets/home/bolt-drive-vec.webp",
  boxes: [
    {
      image: "/assets/home/drive-circle-1.webp",
      title: "60% Rise in Ride Bookings Per Quarter",
    },
    {
      image: "/assets/home/drive-circle-2.webp",
      title: "45% Reduction in Average Pickup Times",
    },
    {
      image: "/assets/home/drive-circle-3.webp",
      title: "35% Lower Operational Costs",
    },
    {
      image: "/assets/home/drive-circle-4.webp",
      title: "44% Boost in Revenue Generation",
    },
    {
      image: "/assets/home/drive-circle-5.webp",
      title: "75% Rise in Customer Loyalty and Repeat Rides",
    },
    {
      image: "/assets/home/drive-circle-6.webp",
      title: "58% Growth in Positive Customer Feedback Every Quarter",
    },
  ],
}

const journeyData = {
  titlePart1: "Our Taxi App Development Process That",
  titlePart2: "Drives Your Business Forward",
  description: "Planning to launch a Vá de Táxi-style app? Here's a simplified view of how it works to ensure smooth operations and high user satisfaction:",
  image: "/assets/home/bolt-journey.webp",
  vector: "/assets/home/bolt-journey-vec.webp",
}

const buildData = {
  titlePart1: "We Build Taxi Booking Apps",
  titlePart2: "Using Advanced Features",
  description: "At Mobility Infotech, our Vá de Táxi Clone app integrates cutting-edge technology to enhance usability, safety, and fleet performance. Here are the innovations that power our system:",
  btn: "more features",
  tabs: [{
    title: "AI-Powered Route Optimization",
    description: "Leverage real-time AI for faster, more fuel-efficient travel. Avoid delays and ensure punctual rides across Brazilian cities.",
    icon: "/assets/home/bolt-build-icon-1.webp",
    image: "/assets/home/bolt-build-1.webp",
  },
  {
    title: "IoT for Vehicle Tracking",
    description: "Enable live tracking, predictive maintenance alerts, and real-time insights for drivers and fleet managers.",
    icon: "/assets/home/bolt-build-icon-2.webp",
    image: "/assets/home/bolt-build-2.webp",
  },
  {
    title: "Chatbots for Customer Support",
    description: "Let AI-powered bots assist customers with bookings, cancellations, and queries 24/7—freeing up your support team.",
    icon: "/assets/home/bolt-build-icon-3.webp",
    image: "/assets/home/bolt-build-3.webp",
  },
  {
    title: "Blockchain for Secure Payments",
    description: "Add an extra layer of trust with tamper-proof, blockchain-based transactions. Reduce fraud, protect user data.",
    icon: "/assets/home/bolt-build-icon-4.webp",
    image: "/assets/home/bolt-build-4.webp",
  },
  {
    title: "Intelligent Driver Matching System",
    description: "Smart algorithms match riders with nearby, high-rated drivers for faster and safer pick-ups.",
    icon: "/assets/home/bolt-build-icon-5.webp",
    image: "/assets/home/bolt-build-5.webp",
  },
  {
    title: "AR for Enhanced Navigation",
    description: "Use Augmented Reality to provide drivers with better directions, landmark info, and navigation in dense urban areas.",
    icon: "/assets/home/bolt-build-icon-6.webp",
    image: "/assets/home/bolt-build-6.webp",
  },],
}

const forYouData = {
  newClass: "bolt-for-you",
  text: "Mobility Infotech Will",
  text2: "Build a White-Label Taxi Booking",
  title: "App Just for You",
  btn: "BEGIN NOW!",
}

const developementData = {
  titlePart1: "Key Features of Our ",
  titlePart2: "Vá de Táxi Clone App ",
  titlePart3: "Development",
  description: "Work with Mobility Infotech to create a robust, flexible, and scalable ride-booking app tailored for Brazil’s transport ecosystem.",
  btn: "Get Started",
  customer: {
    image: "/assets/home/bolt-developement-1.webp",
    title: "Customer App",
    description: "An intuitive, user-friendly app designed for Brazilian passengers to enjoy quick, safe, and reliable ride bookings with real-time features and flexible payment options.",
    boxes: [
      {
        title: "Seamless Ride Booking",
        desc: "Effortlessly book rides with a clean, localized UI optimized for fast confirmations and a stress-free experience on any device."
      },
      {
        title: "Flexible Payment Options",
        desc: "Users can choose to pay via debit/credit cards, Pix, wallets, or cash—offering complete flexibility and convenience at checkout."
      },
      {
        title: "Ride Sharing Availability",
        desc: "Passengers can share live ride tracking links with family or friends for added safety and reassurance during their journey."
      },
      {
        title: "Schedule a Rides",
        desc: "Book rides in advance for appointments, airport transfers, or events—ensuring on-time pickups without last-minute stress."
      },
      {
        title: "Live Driver Tracking",
        desc: "Track your driver’s real-time location and estimated arrival time using integrated GPS with traffic-based ETAs."
      },
      {
        title: "Push Notifications",
        desc: "Stay updated with instant alerts about driver arrival, trip status, promos, and more, directly on your smartphone."
      },
    ]
  },
  driver: {
    image: "/assets/home/bolt-developement-2.webp",
    title: "Driver App",
    description: "Built to empower drivers with the tools to manage trips, optimize navigation, and track earnings—ensuring efficient service and higher satisfaction.",
    boxes: [
      {
        title: "Direct Calling",
        desc: "Drivers can instantly call riders from the app for quick coordination or clarification before and during the trip."
      },
      {
        title: "Optimized Route Navigation",
        desc: "Smart GPS guidance offers traffic-aware, turn-by-turn navigation to ensure faster and more efficient rides."
      },
      {
        title: "Start & End Ride Tracking",
        desc: "Easily begin and end trips with a single tap—ensuring accuracy in billing and ride management."
      },
      {
        title: "Built-In Help & Support",
        desc: "Access quick support from the app for any trip or technical issues—ensuring smoother operations on the road."
      },
      {
        title: "Earnings Dashboard",
        desc: "Track income daily, weekly, or monthly with a clear overview of completed trips and total earnings."
      },
      {
        title: "In-App Chat",
        desc: "Communicate securely with passengers through a real-time chat feature without sharing phone numbers."
      },
    ]
  },
  dispatcher: {
    image: "/assets/home/bolt-developement-3.webp",
    title: "Dispatcher Dashboard",
    description: "A powerful backend system that helps taxi businesses monitor, dispatch, and manage fleet operations efficiently in real time.",
    boxes: [
      {
        title: "Automatic Dispatching",
        desc: "Automatically assigns the nearest available driver to every ride request—reducing wait times and maximizing efficiency."
      },
      {
        title: "Booking Management",
        desc: "Track, assign, and manage all ride requests in real-time from a single control panel."
      },
      {
        title: "Live Fleet Tracking",
        desc: "View live locations and statuses of all drivers on the road via an interactive fleet map."
      },
      {
        title: "Push Alerts for Dispatch",
        desc: "Instantly notify drivers of assigned trips or route changes using real-time push notifications."
      },
      {
        title: "Smart Route Planning",
        desc: "Suggests optimal routes based on traffic and distance—minimizing fuel usage and driver fatigue."
      },
      {
        title: "Complete Transaction History",
        desc: "Access full logs of every completed, ongoing, or cancelled trip for reporting and analysis."
      },
    ]
  },
  admin: {
    image: "/assets/home/bolt-developement-4.webp",
    title: "Admin Panel",
    description: "The command center for your entire taxi business—equipping you to oversee operations, performance, and growth strategies with ease.",
    boxes: [
      {
        title: "Driver Supervision",
        desc: "Add, remove, or manage driver profiles and verify credentials from a central admin dashboard."
      },
      {
        title: "In-Depth Analytics",
        desc: "Access real-time data on bookings, earnings, driver activity, and user behavior for better decision-making."
      },
      {
        title: "Integrated Payment Management",
        desc: "Manage customer payments, refunds, and driver payouts—all from a secure backend system."
      },
      {
        title: "Promo & Loyalty Management",
        desc: "Create, launch, and monitor promotional codes, referral programs, and loyalty rewards for passengers."
      },
      {
        title: "Real-Time Admin Chat",
        desc: "Chat directly with your support team or drivers to resolve issues quickly and ensure smooth operations."
      },
      {
        title: "Booking Oversight",
        desc: "Track every ride—scheduled, ongoing, or completed—and step in if manual intervention is needed."
      },
    ]
  },
}

const customData = {
  titlePart1: "Tailored Taxi App Solutions",
  titlePart2: "for Every Industry",
  description: "From taxi fleet businesses and travel agencies to large enterprises, our customizable, high-performance taxi booking apps are designed to elevate user experience and simplify your operational workflows.",
  slides: [
    {
      image: "/assets/home/bolt-custom-slide-1.webp",
      title: "Corporate Transportation Providers",
      desc: "Transform daily commutes with optimized routes, punctual pickups, and robust backend controls — designed for workforce efficiency and comfort.",
    },
    {
      image: "/assets/home/bolt-custom-slide-2.webp",
      title: "Taxi App for fleet Businesses",
      desc: "Drive business growth with a scalable fleet solution — real-time trip management, automated billing, and performance dashboards that work on autopilot.",
    },
    {
      image: "/assets/home/bolt-custom-slide-3.webp",
      title: "Events Transportation Providers",
      desc: "Elevate guest experiences with precision transport logistics — smart scheduling, VIP ride tracking, and instant updates that keep every journey on cue.",
    },
    {
      image: "/assets/home/bolt-custom-slide-4.webp",
      title: "School And College Operation",
      desc: "Make school transport safer and smarter with AI-powered routing, real-time parent alerts, and secure student check-ins from start to finish.",
    },
    {
      image: "/assets/home/bolt-custom-slide-5.webp",
      title: "Tour & Travel Operation",
      desc: "Deliver smooth, scenic experiences with live itinerary tracking, proactive driver coordination, and effortless group communication at every stop.",
    },
  ]
}

const smartData = {
  titlePart1: "Where",
  titlePart2: "Smart Mobility Meets",
  titlePart3: "Profitable App Business Models",
  description: "Boost ROI through multiple revenue streams:",
  boxes: [
    {
      image: "/assets/home/bolt-smart-1.webp",
      title: "Trip Commissions",
      desc: "Earn per completed ride.",
    },
    {
      image: "/assets/home/bolt-smart-2.webp",
      title: "Surge Pricing",
      desc: "Increase rates during peak demand.",
    },
    {
      image: "/assets/home/bolt-smart-3.webp",
      title: "Reports and Analytics",
      desc: "Offer premium ride options for a fee.",
    },
    {
      image: "/assets/home/bolt-smart-4.webp",
      title: "Cancellation Fees",
      desc: "Offset losses from last-minute cancellations.",
    },
    {
      image: "/assets/home/bolt-smart-5.webp",
      title: "Leasing to Drivers",
      desc: "Generate revenue from vehicle leasing.",
    },
    {
      image: "/assets/home/bolt-smart-6.webp",
      title: "Brand Advertising",
      desc: "Monetise ad space within your app.",
    },
  ]
}

const WhiteLabelData = {
  title: "Develop Your White-Label Taxi Dispatch App with Mobility Infotech",
  description: "With over 10 years of experience and top-tier tech, Mobility Infotech helps you go live with a powerful Vá de Táxi-style app made for Brazil.",
  boxes: [
    {
      image: "/assets/home/bolt-white-1.webp",
      title: "White-Label Solution",
      desc: "Launch your branded app with advanced features.",
    },
    {
      image: "/assets/home/bolt-white-2.webp",
      title: "Ready To Use",
      desc: "Go live in just 3 days.",
    },
    {
      image: "/assets/home/bolt-white-3.webp",
      title: "Highly Scalable",
      desc: "Expand city by city or countrywide.",
    },
    {
      image: "/assets/home/bolt-white-4.webp",
      title: "Seamless Integration",
      desc: "Connect to your current systems smoothly.",
    },
    {
      image: "/assets/home/bolt-white-5.webp",
      title: "Fully Customizable",
      desc: "Design every feature to fit your business.",
    },
    {
      image: "/assets/home/bolt-white-6.webp",
      title: "User-Friendly Interface",
      desc: "Easy for all users, from drivers to customers.",
    },
  ]
}

const genData = {
  titlePart1: "Next-Gen",
  titlePart2: "Taxi App Development",
  titlePart3: "Company Driving Innovation",
  description: "Mobility Infotech empowers your ride-hailing startup with future-ready tech:",
  boxes: [
    {
      image: "/assets/home/lyft-minimum-1.webp",
      title: "Automate dispatch from admin panel.",
    },
    {
      image: "/assets/home/lyft-minimum-2.webp",
      title: "GPS-based real-time driver tracking.",
    },
    {
      image: "/assets/home/lyft-minimum-3.webp",
      title: "Monitor operations live.",
    },
    {
      image: "/assets/home/lyft-minimum-4.webp",
      title: "Access analytics for better decision-making.",
    },
    {
      image: "/assets/home/lyft-minimum-5.webp",
      title: "Integrate multiple payment gateways.",
    },
    {
      image: "/assets/home/lyft-minimum-6.webp",
      title: "Enable rider ratings and trip reviews.",
    },
  ],
}

const globalData = {
  titlePart1: "Proven Impact from",
  titlePart2: "Our Taxi App",
  titlePart3: "Development",
  counter1: {
    number: "70",
    text: "Increase in Potential ROI",
  },
  counter2: {
    number: "64",
    text: "Increase in Customer Satisfaction",
  },
  counter3: {
    number: "40",
    text: "Increase in Bookings",
  },
  counter4: {
    number: "20",
    text: "Reduction in Maintenance Cost",
  },
}

const faqData = [
  {
    id: "0",
    question: "01. What is Mobility Infotech’s Vá de Táxi Clone App?",
    answer: "A scalable, white-label ride-hailing solution designed for the Brazilian taxi market.",
  },
  {
    id: "1",
    question: "02. Why choose Mobility Infotech for app development?",
    answer: "We offer cutting-edge features, fast deployment, and full customization based on your goals.",
  },
  {
    id: "2",
    question: "03. How customizable is the app?",
    answer: "It’s fully customizable—from design and payments to vehicle types and local features.",
  },
  {
    id: "3",
    question: "04. Is post-launch support available?",
    answer: "Yes, we offer 24/7 support, ongoing updates, and system maintenance.",
  },
  {
    id: "4",
    question: "05. How fast can the app go live?",
    answer: "We can launch your app in as little as 3 days.",
  },
  {
    id: "5",
    question: "06. Can it integrate with my existing systems?",
    answer: "Absolutely—payment gateways, CRMs, dispatch tools, and more.",
  },
  {
    id: "6",
    question: "07. What tech is included?",
    answer: "AI routing, IoT tracking, blockchain payments, AR navigation, and chatbot support.",
  },
  {
    id: "7",
    question: "08. How secure is the app?",
    answer: "Bank-level security with encryption and blockchain-based transactions.",
  },
];

export default function VadeTaxi() {
  return (
    <>
      <BoltBanner data={bannerData} />
      <BoltOwnCode data={OwnCodeData} />

      <Suspense fallback={null}>
        <LyftTeamlogo heading={true} newClass="bolt-clone-team" />
        <BoltSuperlative data={superlativeData} />
        <BoltNeed data={needData} />
        <BoltDrive data={driveData} />
        <BoltJourney data={journeyData} />
        <BoltBuild data={buildData} />
        <BoltForYou data={forYouData} />
        <BoltDevelopement data={developementData} />
        <BoltCustom data={customData} />
        <BoltSmart data={smartData} />
        <BoltWhiteLabel data={WhiteLabelData} />
        <BoltGen data={genData} />
        <BoltGlobal data={globalData} />
        <ShuttleAppreciation />
        <div className="zip-faq-fixer">
          <TaxiFaq faqData={faqData} />
        </div>
      </Suspense>
    </>
  )
}
